import { render, staticRenderFns } from "./paper-result.vue?vue&type=template&id=93bfd306&scoped=true"
import script from "./paper-result.vue?vue&type=script&lang=js"
export * from "./paper-result.vue?vue&type=script&lang=js"
import style0 from "./paper-result.vue?vue&type=style&index=0&id=93bfd306&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bfd306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93bfd306')) {
      api.createRecord('93bfd306', component.options)
    } else {
      api.reload('93bfd306', component.options)
    }
    module.hot.accept("./paper-result.vue?vue&type=template&id=93bfd306&scoped=true", function () {
      api.rerender('93bfd306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/paper-result.vue"
export default component.exports